import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Cart from 'lib/api/cart'
import cartDuck from 'components/cart/duck'
import cartItemsDuck from 'components/cart/cart-items/duck'
import styles from './styles.scss'

// isSelected (computed by CartProduct, see its own comment) already
// reconciles the backend's real per-item is_selected (selectable-cart's
// view-product action, merged into cart.payload.items by Cart.getCart,
// lib/api/cart.js) with any toggle made client-side this session -- this
// component just renders that and write-throughs a change to both.
// toggleItemSelected is seeded with defaultSelectedKeys (not
// allSelectableKeys) so the first toggle this session still starts from
// the backend's real selection instead of wrongly assuming everything
// was selected beforehand.
const CartProductCheckbox = ({
  defaultSelectedKeys,
  isSelected,
  itemKey,
  productAttributeID,
  productID,
  setItemSelected,
  toggleItemSelected,
}) => {
  const handleChange = () => {
    toggleItemSelected(itemKey, defaultSelectedKeys)
    // itemKey/allKeys are passed through purely so the creator can undo
    // the optimistic toggle above if selectable-cart rejects the change --
    // they're not part of the request itself.
    setItemSelected({
      type: isSelected ? Cart.UNSELECT_ITEM : Cart.SELECT_ITEM,
      productID,
      productAttributeID,
      itemKey,
      allKeys: defaultSelectedKeys,
    })
  }

  return (
    <div className="cart-product-checkbox">
      <style jsx>{styles}</style>
      <input
        type="checkbox"
        aria-label="Select item"
        checked={isSelected}
        onChange={handleChange}
      />
      <span className="cart-product-checkbox__box" aria-hidden="true" />
    </div>
  )
}

CartProductCheckbox.propTypes = {
  defaultSelectedKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  isSelected: PropTypes.bool.isRequired,
  itemKey: PropTypes.string.isRequired,
  productAttributeID: PropTypes.number.isRequired,
  productID: PropTypes.number.isRequired,
  setItemSelected: PropTypes.func.isRequired,
  toggleItemSelected: PropTypes.func.isRequired,
}

export default connect(null, (dispatch) =>
  bindActionCreators(
    {
      toggleItemSelected: cartItemsDuck.creators.toggleItemSelected,
      setItemSelected: cartDuck.creators.setItemSelected,
    },
    dispatch,
  ),
)(CartProductCheckbox)
